import React, { type ReactElement } from 'react';
import { cheapestProductIDs } from 'reactApp/modules/products/products.const';
import { getPeriodName } from 'reactApp/utils/Period';

export const usePaymentInfo = ({ isGrace, product, subscription, isSuccess }): { title?: string | ReactElement; description?: string } => {
    if (!subscription) {
        return {};
    }

    let title = <div>Продление периода тарифа на&nbsp;{subscription?.space?.value}</div>;

    // tempexp_16598-start
    if (Object.values(cheapestProductIDs).includes(subscription.productId)) {
        title = <div>Продление периода тарифа Без рекламы</div>;
    }
    // tempexp_16598-end

    if (isGrace) {
        title = <div>Оплата подписки Mail Space&nbsp;{subscription?.space?.value}</div>;
    }

    if (isSuccess && !isGrace) {
        // tempexp_16598-start
        if (Object.values(cheapestProductIDs).includes(subscription.productId)) {
            title = <div>Вы продлили тариф Без рекламы</div>;
        }
        // tempexp_16598-end

        title = <div>Вы продлили тариф на&nbsp;{subscription?.space?.value}</div>;
    }

    return {
        title,
        description:
            isGrace && product
                ? `Доплата за подписку +${product.space.space} ${product.space.units} на ${getPeriodName(product.period, false, true)} `
                : undefined,
    };
};
